import axios from 'axios';
import errorInterceptor from './errorInterceptor';

export const baseClient = axios.create({
  baseURL: '/platform',
});

const client = baseClient.create();

client.interceptors.response.use(
  // successful request interceptor: pass through unmodified
  (response) => response,
  // error request interceptor: special handling for 401s
  errorInterceptor,
);

export default client;
